import { create } from 'zustand';
import type { Problem, MoveResult } from '../types';

export interface SolutionMove {
  player: 'B' | 'W';
  coord: string;
  moveNumber: number;
}

interface GameState {
  currentProblem: Problem | null;
  sessionId: string | null;
  moveHistory: string[];
  result: MoveResult | null;
  startTime: number | null;
  hintLevel: number;
  isLoading: boolean;
  solutionPath: SolutionMove[] | null;

  setProblem: (problem: Problem) => void;
  setResult: (result: MoveResult) => void;
  addMove: (coord: string) => void;
  setSessionId: (id: string | null) => void;
  setHintLevel: (level: number) => void;
  setLoading: (loading: boolean) => void;
  setSolutionPath: (path: SolutionMove[] | null) => void;
  reset: () => void;
}

export const useGameStore = create<GameState>((set) => ({
  currentProblem: null,
  sessionId: null,
  moveHistory: [],
  result: null,
  startTime: null,
  hintLevel: 0,
  isLoading: false,
  solutionPath: null,

  setProblem: (problem) => set({
    currentProblem: problem,
    sessionId: null,
    moveHistory: [],
    result: null,
    startTime: Date.now(),
    hintLevel: 0,
    solutionPath: null,
  }),

  setResult: (result) => set({ result }),
  addMove: (coord) => set((s) => ({ moveHistory: [...s.moveHistory, coord] })),
  setSessionId: (id) => set({ sessionId: id }),
  setHintLevel: (level) => set({ hintLevel: level }),
  setLoading: (loading) => set({ isLoading: loading }),
  setSolutionPath: (path) => set({ solutionPath: path }),

  reset: () => set({
    currentProblem: null,
    sessionId: null,
    moveHistory: [],
    result: null,
    startTime: null,
    hintLevel: 0,
    isLoading: false,
    solutionPath: null,
  }),
}));
